import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useParameterStore from '../parameterStore/useParameterStore';
import { signUpStore } from './signUpStore';

const useSignUpStore = createStore({
  creator: signUpStore({
    useParameterStore: lazyDependency(() => useParameterStore),
  }),
  id: 'signUp',
  middlewares: {
    devtools: true,
    persist: true,
  },
});

export default useSignUpStore;
